import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./NavBar";
import Sidebar from "./SideBar";
import { useMediaQuery } from "@mui/material";

const MainLayout: React.FC = () => {
  const isMobile = useMediaQuery("(max-width:960px)");
  const [isClosed, setIsClosed] = useState(false); // Define the isClosed state

  useEffect(() => {
    // Auto close sidebar on mobile
    if (isMobile) {
      setIsClosed(true);
    } else {
      setIsClosed(false);
    }
  }, [isMobile]);
  return (
    <>
      <Sidebar isClosed={isClosed} setIsClosed={setIsClosed} />

      <div className="main-layout">
        <Navbar />
      </div>
      <div className="sub-main-layout">
        <div
          className={`layout-container ${
            isClosed ? "layout-container-close" : ""
          }`}
        >
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MainLayout;
